"use client";

import { BackdropBlurTop } from "@/components/ui/backdrop-blur";
import Banner from "./Banner";
import CompanyMenu from "./company-menu";
import { MobileNavPopover } from "./mobile-nav";
import { HeaderNavigationMenu } from "./navigation-menu";
import NotificationsMenu from "./notifications-menu";
import OptionsMenu from "./options-menu";
// import ProfileMenu from "./ProfileMenu";
import { ProfileMenu } from "./profile-menu";

export const dynamic = "force-dynamic";
export const revalidate = 0;

export default function Header() {
	return (
		<>
			<header className="fixed block top-0 z-50 w-full">
				<BackdropBlurTop className="backdrop-blur-sm" />

				<Banner
					title="Explore your city"
					description="Introducing live city maps"
					link="/join"
					linkText="Join Now"
				/>

				<div className="flex flex-row mx-auto p-3 text-black h-[50px] items-center justify-between backdrop-blur-sm bg-background/50 border-b border-border/20">
					<div className="flex gap-2 items-center justify-center">
						<MobileNavPopover />
						<CompanyMenu />
					</div>

					<HeaderNavigationMenu />

					<div className="flex mt-1 items-center gap-2">
						<OptionsMenu />
						<NotificationsMenu />
						<ProfileMenu />
					</div>
				</div>
			</header>
			<div className="h-[50px] w-full" />
		</>
	);
}
